import { makeAutoObservable } from "mobx";
import { MAX_CROSS_SELLING_ITEM_COUNT, } from "./ICrossSellingCreator";
import { CrossSellingItemInstanceCartBehaviour, CrossSellingItemInstanceFactory, } from "../CrossSellingItemInstance";
export class CartCrossSellingCreator {
    constructor(params) {
        this.purchaseOrderPayload = params.purchaseOrderPayload;
        this.crossSellingItemInstanceFactory =
            params.crossSellingItemInstanceFactory;
        this.purchaseOrderScope = params.purchaseOrderScope;
        makeAutoObservable(this);
    }
    static create(params) {
        const crossSellingItemInstanceFactory = new CrossSellingItemInstanceFactory({
            menu: params.menu,
            listProvider: params.listProvider,
            createBehaviour: (_, productInstanceCreator) => new CrossSellingItemInstanceCartBehaviour({
                purchaseOrderPayload: params.purchaseOrderPayload,
                productInstanceCreator,
            }),
        });
        return new CartCrossSellingCreator({
            purchaseOrderPayload: params.purchaseOrderPayload,
            crossSellingItemInstanceFactory,
            purchaseOrderScope: params.purchaseOrderScope,
        });
    }
    get excludedProductTypeIds() {
        return this.purchaseOrderPayload.productTypeIds;
    }
    get items() {
        return this.crossSellingItemInstanceFactory
            .create(this.purchaseOrderPayload.productTypeIds, this.purchaseOrderScope)
            .filtered((crossSellingItemInstance) => crossSellingItemInstance.shouldAppearInCrossSellingList(this.excludedProductTypeIds))
            .take(MAX_CROSS_SELLING_ITEM_COUNT);
    }
}
